import MonetizationOnIcon from '@mui/icons-material/MonetizationOn'

import Chip from '@mui/material/Chip'

export default function CashPayChip(props = {}) {
  return <Chip icon={<MonetizationOnIcon />} label="Self-Pay" color="success" variant="filled" sx={style} {...props} />
}

const style = {
  boxShadow: '0 3px 5px 2px rgba(76, 175, 80, .3)',
  animation: 'pulse 2s infinite',
  '@keyframes pulse': {
    '0%': {
      boxShadow: '0 3px 5px 2px rgba(76, 175, 80, .3)',
    },
    '50%': {
      boxShadow: '0 3px 15px 5px rgba(76, 175, 80, .5)',
    },
    '100%': {
      boxShadow: '0 3px 5px 2px rgba(76, 175, 80, .3)',
    },
  },
}
